import translationInstance from '../utils/translations';
const t = translationInstance.t.bind(translationInstance);

const PartialConfigs = {
    _id: "section-configurations",
    controlType: "section",
    name: t('virtenzo.configuration.section_configurations'),
    headlineText: t('virtenzo.configurator.section_configurations'),
    actions: [],
    groups: "Configurations",
    classes: [
      "virtenzo-panel-section",
      "section-configurations"
    ],
    subOptions: [
      {
        _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a6',
        actions: [],
        controlType: 'sectionHeadline',
        name: t('virtenzo.configurator.section_configurations'),
        classes: ['virtenzo-panel-section-headline', 'section-root-headline', 'big-headline'],
        href: '',
      },
      {
        _id: "8004c9f8-1534-4601-808b-bae614e372f2",
        actions: [
          {
            _id: "9a87ee91-aa42-4d8b-a61b-b3db44d4ed46",
            functionName: "setMaterialByObjectPrefixMaterialName",
            prefix: "wood",
            materialName: "Beech Taupe"
          },
          {
            _id: "1ac0fff1-e204-4306-8696-913acbbf7f58",
            functionName: "setMaterialByObjectNameMaterialName",
            name: "fabric_top_Piano_13_0",
            materialName: "Piano_13"
          },
          {
            _id: "be804759-3f15-4cc0-aa55-fa5152f9ee52",
            functionName: "setMaterialByObjectNameMaterialName",
            name: "fabric_bottom_Mag 7026_0",
            materialName: "Mag 7026"
          }
        ],
        controlType: "button",
        name: t('virtenzo.configuration') + " 1",
        classes: [
          "virtenzo-panel-button", 'virtenzo-configuration-1'
        ],
        href: "",
        groups: "Wood"
      },
      {
        _id: "b221457f-b902-4214-a89c-13f3d9bcbeff",
        actions: [
          {
            _id: "9be1b63c-5dfb-4965-b19c-65663a3240fa",
            functionName: "setMaterialByObjectPrefixMaterialName",
            prefix: "wood",
            materialName: "American Walnut Natural Oil"
          },
          {
            _id: "809010be-dee3-4279-87b0-064c6e9caa11",
            functionName: "setMaterialByObjectPrefixMaterialName",
            prefix: "fabric_bottom",
            materialName: "Leather black"
          },
          {
            _id: "553ebec1-72ff-4ba1-8bd1-dd7a5c6f6459",
            functionName: "setMaterialByObjectPrefixMaterialName",
            prefix: "fabric_top",
            materialName: "Home_22"
          }
        ],
        controlType: "button",
        name: t('virtenzo.configuration') + " 2",
        classes: [
          "virtenzo-panel-button",
          'virtenzo-configuration-2'
        ],
        href: "",
        groups: "Wood"
      },
      {
        _id: "b6ea34de-0c42-4c51-b99e-e99fda5e41ba",
        actions: [
          {
            _id: "c6481e69-07b0-4b5a-a325-854023a2a459",
            functionName: "setMaterialByObjectPrefixMaterialName",
            prefix: "wood",
            materialName: "Oak Oil Light Grey"
          },
          {
            _id: "11cf1fea-9a80-4bf9-9d7a-9a518144f835",
            functionName: "setMaterialByObjectNameMaterialName",
            name: "fabric_top_Piano_13_0",
            materialName: "Tama_01"
          },
          {
            _id: "2a2b3d1b-2fc6-473d-88ba-54bb58c092af",
            functionName: "setMaterialByObjectNameMaterialName",
            name: "fabric_bottom_Mag 7026_0",
            materialName: "Leather Limestone"
          }
        ],
        controlType: "button",
        name: t('virtenzo.configuration') + " 3",
        classes: [
          "virtenzo-panel-button",
          'virtenzo-configuration-3'
        ],
        href: "",
        groups: "Wood"
      },
      {
        _id: "0c167087-710e-4cbd-b509-ea185d0829e7",
        actions: [
          {
            _id: "c3db8e5f-0c7d-49d6-a8cd-a1b6be178540",
            functionName: "setMaterialByObjectPrefixMaterialName",
            prefix: "wood",
            materialName: "Oak Oil Bianco"
          },
          {
            _id: "092a5396-8302-4432-8663-64ef3decd9ea",
            functionName: "setMaterialByObjectNameMaterialName",
            name: "fabric_top_Piano_13_0",
            materialName: "Tis 04"
          },
          {
            _id: "ea978965-8a50-4091-aebe-90907d722a68",
            functionName: "setMaterialByObjectNameMaterialName",
            name: "fabric_bottom_Mag 7026_0",
            materialName: "Leather caffee latte"
          }
        ],
        controlType: "button",
        name: t('virtenzo.configuration') + " 4",
        classes: [
          "virtenzo-panel-button",
          'virtenzo-configuration-4'
        ],
        href: "",
        groups: "Wood"
      },
      {
        _id: "f2d0aa98-35ad-421d-8ae6-1611d08100b9",
        actions: [
          {
            _id: "bd19649e-d950-4315-82a8-b9884393aa0b",
            functionName: "setMaterialByObjectPrefixMaterialName",
            prefix: "wood",
            materialName: "Oak Carbon"
          },
          {
            _id: "6ea62921-ef6b-41eb-9722-45a3f8516f8d",
            functionName: "setMaterialByObjectNameMaterialName",
            name: "fabric_top_Piano_13_0",
            materialName: "Haga 900"
          },
          {
            _id: "8c0db39a-4135-4c73-a28c-220b22752da3",
            functionName: "setMaterialByObjectNameMaterialName",
            name: "fabric_bottom_Mag 7026_0",
            materialName: "Leather Drak graphite"
          }
        ],
        controlType: "button",
        name: t('virtenzo.configuration') + " 5",
        classes: [
          "virtenzo-panel-button",
          'virtenzo-configuration-5'
        ],
        href: "",
        groups: "Wood"
      },

    ]
  };

  export default PartialConfigs;